import { Box } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';

import { Subtitle } from '../Atoms/AprSubTitle';
import { VaultCardLeftBody } from '../Atoms/VaultCardLeftBody';

export const VaultCardNotConnected = () => {
  const t = useTranslations();
  return (
    <VaultCardLeftBody>
      <Box>
        <Subtitle> {t('common.Connect wallet to stake')} </Subtitle>
      </Box>
    </VaultCardLeftBody>
  );
};
